import type { ShadowComparisonResult } from './compareShadow';

export type LogFn = (
  message: string,
  context?: Record<string, unknown>
) => void;

export function logShadowMismatch(
  result: ShadowComparisonResult<unknown>,
  log: LogFn
): void {
  if (result.match) {
    return;
  }

  log(`Shadow mismatch: ${result.label}`, {
    diff: result.diff,
  });
}
